import { fetchWrapper, handleResponse, hcUrlV3, buildOpts } from 'services/RequestService/helpers';

export const getMealSellouts = async ({ params: { menuSlug } }) => {
  const response = await fetchWrapper(hcUrlV3(`/menus/${menuSlug}/meal_sellouts`), buildOpts());
  return handleResponse(response);
};
